import styled from 'styled-components'
import { Link } from 'react-router-dom'
import ChatIcon from '@material-ui/icons/Chat';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';

export const UserCommentList = styled.ul`
    width: 100%;
    list-style: none;
`

export const CommentItem = styled.li`
    border-top: 1px solid #e9e9e9;
    padding: 12px 0;
    padding-left: 19px;

    @media screen and (max-width: 1023px) {
        padding-left: 0;
    }

`

export const NewsTitle = styled(Link)`
    margin-bottom: 10px;
    font-size: 14px;
    font-weight: bold;
    color: #222;
    text-decoration: none;
    display: block;
    line-height: 1.4;
`

export const CommentDesc = styled.div`
    padding: 12px;
    background-color: #f0f0f0;
    line-height: 1.31;
    font-size: 13px;
    display: flex;
`

export const CommentIc = styled(ChatIcon)`
    color: #727b88;
    font-size: 20px;
    margin-top: 2px;

    @media screen and (max-width: 767px) {
        font-size: 18px !important;
    }
`

export const CommentDescBody = styled.div`
    margin-left: 10px;

    @media screen and (max-width: 767px) {
        margin-left: 8px;
    }
`

export const CommentText = styled.p`
    margin-bottom: 8px;
    display: block;
    color: #333;
`

export const CommentDescBodyBottom = styled.div`
    display: flex;
    align-items: center;
`

export const LikeButton = styled.div`
    display: flex;
    align-items: center;
    color: #727b88;
    cursor: default;

    @media screen and (max-width: 767px) {
        margin-bottom: 1px;
    }
`

export const CommentLikeIc = styled(ThumbUpIcon)`
    font-size: 14px !important;
    margin-right: 4px;
`

export const Replies = styled.span`
    color: #727b88;
    font-size: 12px;
    margin-left: 16px;
`

export const CommentAt = styled.span`
    color: #727b88;
    font-size: 12px;
    margin-left: 16px;
`

export const EmtyComment = styled.h2`
    color: #333;
    font-size: 16px;
    text-align: center;
    margin-top: 40px;
    margin-bottom: 100px;
`

